import styled from 'styled-components';

export const Container = styled.div`
	display: flex;
	align-items: center;
	position: relative;
`;

export const SearchLabel = styled.label`
	position: absolute;
	top: calc(50% - 0.5rem);
	left: 1rem;
	cursor: text;
	line-height: 0.75rem;
`;

export const ClearButton = styled.button`
	position: absolute;
	top: calc(50% - 0.5625rem);
	right: 0.5rem;
	outline: none;
	border: 0;
	background: transparent;
	cursor: pointer;
	line-height: 0.875rem;

	&:focus {
		outline: none;
	}
`;
